import script from "./TechStackSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TechStackSection.vue?vue&type=script&setup=true&lang=js"

import "./TechStackSection.vue?vue&type=style&index=0&id=0699b36f&scoped=true&lang=scss"

import exportComponent from "/Users/kadir.aslan/Projects/Repositories/Personal/kadiraslan-de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0699b36f"]])

export default __exports__